import { render, staticRenderFns } from "./actions_mobile.vue?vue&type=template&id=996b212c&scoped=true&"
import script from "./actions_mobile.vue?vue&type=script&lang=js&"
export * from "./actions_mobile.vue?vue&type=script&lang=js&"
import style0 from "./actions_mobile.vue?vue&type=style&index=0&id=996b212c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996b212c",
  null
  
)

export default component.exports